<template>
  <el-form inline size="mini" :model="formData" :rules="rules" ref="form" label-width="97px"
           class="part-base-party-a-container">
    <template>
      <div class="card-title">客户信息
        <el-link type="primary" v-if="formData.id >= 1 && formData.pid >= 1" class="el-icon-refresh" @click="syncCustomerBtn" />
      </div>
      <div class="form-card" :class="{disabled}">
        <div class="main">
          <el-form-item :label="'客\u3000\u3000户'" prop="customer_name">
            <div style="display: flex;" class="customer-combine">
              <div v-if="formData.customer_name" class="combine">集团：{{ formData.combine_name || '无' }}</div>
              <div class="input-val" @click="dialogCustomerVisible=true">
                <span v-if="formData.customer_name" class="customer_name form-val">{{ formData.customer_name }}</span>
                <el-link v-else type="primary" style="flex: 4;text-align: center;font-weight: 400"
                         @click="dialogCustomerVisible=true">点击选择客户及其销售
                </el-link>
              </div>
              <el-link v-if="type==='add'" :underline="false" type="primary" @click="switchAddCustomer"
                       icon="el-icon-circle-plus" style="font-weight: 800;width: 30px;">
              </el-link>
              <div v-if="formData.form_of_cooperation === '年框大全案'" style="padding-left: 5px">
                <i class="el-icon-edit-outline" style="cursor: pointer" @click="dialogCustomerVisible=true" />
              </div>
            </div>
          </el-form-item>
          <el-form-item :label="'客户别名'" class="custom-form-item">
            <!--            <el-input class="el-input-c" v-model="formData.customer_name_custom"/>-->
            <!--            {{formData.customer_name_custom}}//?-->
            <el-input class="el-input-c"
                      v-model="formData.customer_name_custom"
                      v-if="editField==='customer_name_custom'||!formData.customer_name_custom"
                      @blur="clearEditField"
                      @focus="selectEditField('customer_name_custom')"
                      placeholder="请输入客户别名" maxlength="32" show-word-limit clearable></el-input>
            <div class="input-val" @click="selectEditField('customer_name_custom')" v-else>
              <span class="customer_name_custom">{{ formData.customer_name_custom }}</span>
            </div>
          </el-form-item>
          <el-form-item v-if="isPreExecutor" :label="'执\u3000\u3000行'" prop="pre_executor_id">
            <el-select v-model="formData.pre_executor_id"
                       placeholder="请选择执行"
                       v-if="editField==='pre_executor'||!formData.pre_executor"
                       @change="selectedExecutor"
                       @focus="selectEditField('pre_executor')"
                       filterable
                       clearable>
              <el-option-group :label="`可选执行(${executorOptions?executorOptions.length:0})`">
                <el-option v-for="(item, index) in executorOptions" :key="index" :label="item.label"
                           :value="item.value"/>
              </el-option-group>
            </el-select>
            <div class="input-val" @click="selectEditField('pre_executor')" v-else>
              <span class="executor">{{ formData.pre_executor }}</span>
            </div>
          </el-form-item>
          <el-form-item :label="'销\u3000\u3000售'" prop="sale_id">
            <div class="input-val" @click="dialogCustomerVisible=true">
              <span class="sale form-val">
                {{ formData.sale || '/' }}{{
                  formData.organization_name ? `\u3000/\u3000` + formData.organization_name : ''
                }}
              </span>
            </div>
          </el-form-item>
          <el-form-item v-if="isWcm" :label="'招\u3000\u3000商'" prop="commerce_id">
            <el-select v-model="formData.commerce_id"
                       placeholder="请选择招商"
                       v-if="editField==='commerce'||!formData.commerce"
                       @change="selectedCommerce"
                       @focus="selectEditField('commerce')"
                       filterable
                       clearable>
              <el-option-group :label="`可选招商(${commerceOption?commerceOption.length:0})`">
                <el-option v-for="(item, index) in commerceOption" :key="index" :label="item.label"
                           :value="item.value"/>
              </el-option-group>
            </el-select>
            <div class="input-val" @click="selectEditField('commerce')" v-else>
              <span class="executor">{{ formData.commerce }}</span>
            </div>
          </el-form-item>
          <el-form-item label="客户性质" prop="customer_nature">
            <el-select v-model="formData.customer_nature"
                       placeholder="请选择客户性质"
                       v-if="editField==='customer_nature'||!formData.customer_nature"
                       @change="clearEditField"
                       @focus="selectEditField('customer_nature')"
                       filterable clearable>
              <el-option-group :label="`客户性质如下(${customerNaturesOptions?customerNaturesOptions.length:0})`">
                <el-option v-for="(item, index) in customerNaturesOptions" :key="index" :label="item.label"
                           :value="item.value"/>
              </el-option-group>
            </el-select>
            <div class="input-val" @click="selectEditField('customer_nature')" v-else>
              <span class="customer_nature">{{ formData.customer_nature }}</span>
            </div>
          </el-form-item>
          <el-form-item :label="'品\u3000\u3000牌'" prop="brand">
            <div style="display: flex;">
              <el-select class="el-input-c" v-model="formData.brand"
                         placeholder="请输入品牌名称"
                         v-if="editField==='brand'||!formData.brand"
                         @focus="()=>{loadBrandOptions();selectEditField('brand')}"
                         @change="clearEditField"
                         filterable
                         clearable>
                <el-option-group :label="`品牌(${brandOptions?brandOptions.length:0})`">
                  <el-option
                      v-for="item in brandOptions"
                      :key="item.brand"
                      :label="item.brand"
                      :value="item.brand">
                  </el-option>
                </el-option-group>
              </el-select>
              <div class="input-val" @click="selectEditField('brand')" v-else>
                <span class="brand">{{ formData.brand }}</span>
              </div>
              <el-link v-if="type==='add'" :underline="false" type="primary" @click="switchAddBrand"
                       icon="el-icon-circle-plus" style="font-weight: 800;width: 30px;">
              </el-link>
            </div>
          </el-form-item>
          <el-form-item :label="'品牌集团'">
            <el-select class="el-input-c" v-model="formData.combine_brand_name"
                       placeholder="请输入品牌集团名称"
                       @change="handleCombineBrandChange"
                       filterable
                       remote
                       :remote-method="searchCombineBrand"
                       :loading="combineBrandLoading"
                       clearable>
              <el-option
                  v-for="item in combinedBrandOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="'行\u3000\u3000业'" prop="trade">
            <el-select class="el-input-c"
                       v-model="formData.trade"
                       v-if="editField==='trade'||!formData.trade"
                       placeholder="请选择行业"
                       @change="clearEditField"
                       @focus="selectEditField('trade')"
                       filterable clearable>
              <el-option-group :label="`行业(${customerTypesOptions?customerTypesOptions.length:0})`">
                <el-option
                    v-for="item in customerTypesOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-option-group>
            </el-select>
            <div class="input-val" @click="selectEditField('trade')" v-else>
              <span class="trade">{{ formData.trade }}</span>
            </div>
          </el-form-item>
          <el-form-item :label="'产\u3000\u3000地'" prop="place_of_origin">
            <el-select v-model="formData.place_of_origin"
                       placeholder="请选择产地"
                       v-if="editField==='place_of_origin'||!formData.place_of_origin"
                       @change="clearEditField"
                       allow-create
                       @focus="selectEditField('place_of_origin')"
                       filterable clearable>
              <el-option-group :label="`产地如下`">
                <el-option v-for="(item, index) in placeOfOrigin" :key="index" :label="item.text"
                           :value="item.text"/>
              </el-option-group>
            </el-select>
            <div class="input-val" @click="selectEditField('place_of_origin')" v-else>
              <span class="customer_nature">{{ formData.place_of_origin }}</span>
            </div>
          </el-form-item>
          <el-form-item :label="'产\u3000\u3000品'" prop="product" class="double-width-item">
            <el-input
                      v-model="formData.product"
                      v-if="editField==='product'||!formData.product"
                      @blur="clearEditField"
                      @focus="selectEditField('product')"
                      placeholder="请输入产品名称(限制32个字符)" maxlength="32" show-word-limit clearable></el-input>
            <div style="max-width: 351px;" :style="!isWcm?{width: '94%!important'}:''"
                 class="input-val"
                 @click="selectEditField('product')" v-else>
              <span class="product">{{ formData.product }}</span>
            </div>
          </el-form-item>
          <el-form-item label="订单来源" prop="order_source">
            <el-select class="el-input-c"
                       v-model="formData.order_source"
                       v-if="editField==='order_source'||!formData.order_source"
                       placeholder="请选择订单来源"
                       @change="clearEditField"
                       @focus="selectEditField('order_source')"
                       filterable
                       clearable>
              <el-option-group :label="`订单来源(${orderSourceOptions?orderSourceOptions.length:0})`">
                <el-option
                    v-for="item in orderSourceOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-option-group>
            </el-select>
            <div class="input-val" @click="selectEditField('order_source')" v-else>
              <span class="order_source">{{ formData.order_source }}</span>
            </div>
          </el-form-item>
          <el-form-item :label="'客\u3000\u3000单'" prop="passenger_order_interval">
            <el-select class="el-input-c"
                       v-model="formData.passenger_order_interval"
                       v-if="editField==='passenger_order_interval'||!formData.passenger_order_interval"
                       placeholder="请选择客单"
                       @change="clearEditField"
                       @focus="selectEditField('passenger_order_interval')"
                       filterable
                       clearable>
              <el-option-group :label="`客单区间(${poiOptions?poiOptions.length:0})`">
                <el-option
                    v-for="item in poiOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-option-group>
            </el-select>
            <div v-else class="input-val" @click="selectEditField('passenger_order_interval')">
              <span class="passenger_order_interval">{{ formData.passenger_order_interval }}</span>
            </div>
          </el-form-item>
          <el-form-item :label="'品\u3000\u3000类'" prop="product_category">
            <el-select class="el-input-c"
                       v-model="formData.product_category"
                       v-if="editField==='product_category'||!formData.product_category"
                       placeholder="请选择品类"
                       @change="clearEditField"
                       @focus="selectEditField('product_category')"
                       filterable
                       clearable>
              <el-option-group :label="`品类(${productCategoriesOptions?productCategoriesOptions.length:0})`">
                <el-option
                    v-for="item in productCategoriesOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-option-group>
            </el-select>
            <div class="input-val" @click="selectEditField('product_category')" v-else>
              <span class="product_category">{{ formData.product_category }}</span>
            </div>
          </el-form-item>
          <el-form-item label="合作形式" v-if="formData.is_mark===1||formData.project_type===3"
                        prop="form_of_cooperation">
            <div class="input-val">
              <span class="form_of_cooperation">{{ formData.form_of_cooperation }}</span>
            </div>
          </el-form-item>
          <el-form-item label="合作形式" prop="form_of_cooperation" v-else>
            <div style="display: flex;">
              <el-select class="el-input-c"
                         v-model="formData.form_of_cooperation"
                         v-if="editField==='form_of_cooperation'||!formData.form_of_cooperation"
                         placeholder="请选择合作形式"
                         @change="()=>{clearEditField();linkData()}"
                         @focus="selectEditField('form_of_cooperation')"
                         filterable
                         clearable>
                <el-option-group :label="`合作形式(${focOptions?focOptions.length:0})`">
                  <el-option
                      v-for="item in focOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                      :disabled="disabledCooperation(item.value)"
                  >
                  </el-option>
                </el-option-group>
              </el-select>
              <div v-else class="input-val" @click="selectEditField('form_of_cooperation')">
                <span class="form_of_cooperation">{{ formData.form_of_cooperation }}</span>
              </div>
              <el-tooltip class="item" effect="dark" :content="tooltip" placement="top-start"
                          style="margin-left: 4px;">
                <el-button type="text" icon="el-icon-info" style="font-size: 14px;"/>
              </el-tooltip>
            </div>
          </el-form-item>
          <el-form-item label="执行公司" prop="exec_customer_name">
            <div>
              <el-select v-model="formData.exec_customer_id"
                         filterable
                         placeholder="请选择执行公司"
                         :loading="execCorpOptionLoading"
                         @change="handleSelect">
                <el-option
                    v-for="item in formData.exec_corp"
                    :key="item.corp_id"
                    :label="item.corp_nm"
                    :value="item.corp_id">
                </el-option>
              </el-select>
            </div>
          </el-form-item>

          <el-form-item label="红人名称" prop="artist_nms" v-if="isMark||formData.pid||formData.is_mark">
            <div>
              <el-select class="el-input-c"
                         multiple
                         v-model="formData.artist_ids"
                         @change="setArtistNames"
                         placeholder="请选择红人"
                         v-if="editField==='artist_nms'||!formData.artist_ids||!formData.artist_ids.length"
                         @focus="selectEditField('artist_nms')"
                         filterable
                         clearable>
                <el-option-group :label="`网红（KOL）/ 经纪人(${kolOptions.length})`">
                  <el-option
                      v-for="item in kolOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    <span style="float: left">{{ item.label }}</span>
                    <span style="float: left; color: #8492a6; font-size: 13px"> / {{ item.agent_name }}</span>
                    <span style="float: left; color: #8492a6; font-size: 13px"> / {{ item.id }}</span>
                  </el-option>
                </el-option-group>
              </el-select>
              <div class="input-val" @click="selectEditField('artist_nms')" v-else>

                <span class="artist_name" :title="formData.artist_ids">{{ formData.artist_nm_str }}</span>
                <!--                <span class="artist_name" :title="formData.artist_id">{{ formData.artist_nms ? formData.artist_nms.join('，') : '' }}</span>-->
              </div>
            </div>
          </el-form-item>
        </div>
      </div>
    </template>

    <!--    追加品牌（客户+销售）-->
    <add-brand
        :show="showAddBrand"
        :brands="brandOptions||[]"
        :id="Number(formData.customer_id)"
        :sale-id="Number(formData.sale_id)"
        @close="switchAddBrand"
        @success="pushBrand"
    />

    <!--    客户销售选择-->
    <CustomerSelectDialog :visible.sync="dialogCustomerVisible" @selected="selectedCustomer"
                          :customer-name="formData.customer_name"/>
  </el-form>
</template>

<script>
import AddBrand from "@/views/adOrder/components/addBrand";
import CustomerSelectDialog from "@/views/adOrder/components/detail/CustomerSelectDialog";
import {getOptionExecutor, getOptionPlaceOrigin} from "@/api/option";
import {customerSaleForOrder, syncMainInfo} from "@/api/adOrder";
import {getFBoyOption} from "@/api/fboy";
import {getOptionCommerce} from "../../../../api/option";
import {execCorpSearchOption} from "@/api/customers";
import {getCombineBrandOptions} from "@/api/combine";

/**
 * 客户资料
 * 甲方模块 PartyA
 * @description 保存订单页面
 */
export default {
  name: "PartBasePartyA",
  components: {AddBrand, CustomerSelectDialog},
  props: {
    formData: {
      type: Object,
      required: true
    },
    editField: {
      type: String
    },
    type: {
      type: String,
      default() {
        return 'add'
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isPreExecutor: {
      type: Boolean,
      default() {
        return false
      }
    },
    pt: Number,
  },
  data() {
    return {
      showAddBrand: false,
      dialogCustomerVisible: false,
      executorOptions: [],
      commerceOption: [],
      brandOptions: [], // 品牌
      myCustomerInfo: {},//销售的客户信息：客户性质 代理品牌 客户行业 等
      customerNaturesOptions: [], // 客户性质
      placeOfOrigin: [], // 产地
      customerTypesOptions: [], // 行业选项
      orderSourceOptions: [], // 订单来源选项
      poiOptions: [], // 客单区间选项
      productCategoriesOptions: [], // 品类选项
      focOptions: [],//合作形式选项
      kolOptions: [],//KOL选项
      fromType: null,
      execCorpOptionLoading: false,
      combineBrandOptions: [],
      combineBrandLoading: false
    }
  },
  watch: {
    "formData.brand"(v) {
      const obj = this.brandOptions.find(_ => {
        return _.brand === v
      })
      if (!obj) {
        return;
      }
      if (obj.combine_brand_id) {
        this.formData.combine_brand_id = obj.combine_brand_id
        this.formData.combine_brand_name = obj.combine_brand_name
      } else {
        this.formData.combine_brand_id = null
        this.formData.combine_brand_name = null
      }
    },
    "formData.artist_id": {
      immediate: true,
      handler(_) {
        if (_ === 0) {
          this.formData.artist_id = null
        }
      }
    },
  },
  computed: {
    rules() {
      const rules = {...{}, ...this.$parent.rules}
      const route_name = this.$route.name
      if (['createAdOrderWcm', 'editAdOrderWcm'].includes(route_name)) {
        // 全案营销、年框大全案时候（①执行必填；②招商必填；③红人必填）
        rules.pre_executor_id = [{required: true, message: '请选择执行', trigger: 'change'},]
        rules.artist_nms = [{required: true, message: '请选择红人', trigger: 'change'},]
      } else {
        if (rules.pre_executor_id !== undefined) {
          delete rules.pre_executor_id
        }
      }

      return rules
    },
    tooltip() {
      let tips = ''
      if (this.formData.is_mark) {
        tips = '“全案营销”仅限全案营销订单'
      } else if (this.formData.project_type === 3) {
        tips = '“普客打包”仅限普客打包订单'
      }
      return tips
    },
    isMark() {
      return this.fromType === 'mark'

    },
    maxKol() {
      if (this.formData.is_mark === 1 && this.formData.form_of_cooperation === '红人全案') {
        return 1
      }
      return 0
    },
    isPureLive() {
      const {isPureLive} = this.$route.query
      return isPureLive && isPureLive === 'true'
    },
    isWcm() {
      return ['createAdOrderWcm', 'editAdOrderWcm'].includes(this.$route.name) || this.fromType === 'mark' || (parseInt(this.formData.is_mark) === 1)
    },
    combinedBrandOptions() {
      const options = [...this.combineBrandOptions]
      if (this.formData.combine_brand_id && this.formData.combine_brand_name) {
        const exists = options.some(item => item.value == this.formData.combine_brand_id)
        if (!exists) {
          options.unshift({
            label: this.formData.combine_brand_name,
            value: this.formData.combine_brand_id
          })
        }
      }
      return options
    }
  },
  mounted() {
    this.initOptionExecutor()
    this.initOptionCommerce()
    this.getKolList()
    this.fromType = this.$route.query && this.$route.query.from
  },
  methods: {
    init: function () {
      // const that = this
      // const {is_mark, project_type, form_of_cooperation} = this.formData
      // if (parseInt(is_mark) === 1 || parseInt(project_type) === 3) {
      //   if (!form_of_cooperation) {
      //     that.showToast({h: that, icon: "el-icon-error", text: '链接已失效！即将返回列表页', duration: 3000});
      //     setTimeout(() => {
      //       that.$router.push({})
      //     }, 3000)
      //   }
      // }
    },
    validateForm() {
      let form = Object.assign({}, this.formData);
      this.$refs.form.validate((bool) => {
        if (!bool) {
          form = bool
        }
      });
      return form
    },
    setOptions(OptionsObj) {
      for (const key in OptionsObj) {
        this.$set(this, key, OptionsObj[key])
        // this[key] = OptionsObj[key]
      }
    },
    switchAddCustomer() {
      const {href} = this.$router.resolve({
        name: `addCustom`
      });
      window.open(href, "_blank");
    },
    switchAddBrand() {
      this.showAddBrand = !this.showAddBrand
    },
    clearEditField() {
      this.$emit('clearEditField');
    },
    selectedCustomer(data) {
      const customer_id = this.formData.customer_id
      this.formData.customer_name = data.customer_name
      this.formData.customer_id = data.customer_id
      this.formData.sale_id = data.sale_id
      this.formData.sale = data.sale
      this.formData.combine_id = data.combine_id
      this.formData.combine_name = data.combine_name
      this.formData.organization_id = data.organization_id
      this.formData.organization_name = data.organization_name

      this.dialogCustomerVisible = false
      this.getCustomerSaleForOrder() //加载客户与销售的品牌下拉数据
      // 重新加载执行公司列表
      if (customer_id !== this.formData.customer_id) {
        this.loadExecCorpOption()
      }
    },
    //获取销售的客户信息：（触发条件：选择销售）
    getCustomerSaleForOrder() {
      this.brandOptions = []
      this.clearEditField()
      this.loadBrandOptions()
    },
    async loadBrandOptions() {
      if (this.brandOptions.length === 0) {
        const customer_id = this.formData.customer_id
        const sale_id = this.formData.sale_id
        if (customer_id && sale_id) {
          await customerSaleForOrder({customer_id: customer_id, sale_id: sale_id})
              .then((res) => {
                const row = res.model
                this.myCustomerInfo = res.model || {}
                if (!this.formData.invoice_title)
                  this.formData.invoice_title = row ? row.invoice_title : ''

                if (!this.formData.customer_nature)
                  this.formData.customer_nature = row ? row.nature : ''

                // if (!this.formData.trade)
                //   this.formData.trade = row ? row.type : ''

                this.brandOptions = row ? row.brands : []
              })
        } else {
          this.$notify.warning('请先选择客户和销售')
        }
      }
    },
    pushBrand(event) {
      this.brandOptions = event[0]
      this.formData.brand = event[1]
    },
    async searchCombineBrand(query) {
      if (!query) {
        this.combineBrandOptions = []
        return
      }
      this.combineBrandLoading = true
      try {
        const res = await getCombineBrandOptions({name: query})
        this.combineBrandOptions = (res.model || []).map(item => ({
          label: item.name,
          value: item.id
        }))
      } finally {
        this.combineBrandLoading = false
      }
    },
    handleCombineBrandChange(val) {
      if (val) {
        const selected = this.combineBrandOptions.find(item => item.value == val)
        this.$set(this.formData, 'combine_brand_id', selected ? selected.value : '')
        this.$set(this.formData, 'combine_brand_name', selected ? selected.label : '')
      } else {
        this.$set(this.formData, 'combine_brand_id', null)
        this.$set(this.formData, 'combine_brand_name', null)
      }
      this.$forceUpdate()
    },
    //初始化执行列表
    initOptionExecutor() {
      getOptionExecutor().then(res => {
        this.executorOptions = res.model || [];
      });

      getOptionPlaceOrigin().then(res => {
        this.placeOfOrigin = res.model.data || []
      })
    },
    initOptionCommerce() {
      getOptionCommerce().then(res => {
        this.commerceOption = res.model || [];
      });
    },
    //选择合作方式联动数据设置
    linkData() {
      //创建订单时候触发
      if (!this.formData.id) {
        // this.$msgbox.alert(this.formData.form_of_cooperation)
        //若选择合作形式为“广告+直播”，则发布平台默认为“直播”,内容形式默认为“混场直播” @20220520
        if (this.formData.form_of_cooperation === '广告+直播') {
          if (this.formData.platforms.indexOf('直播') === -1)
            this.formData.platforms.push('直播')
          if (this.formData.content_forms.indexOf('混场直播') === -1)
            this.formData.content_forms.push('混场直播')
        }
      }
    },
    /**
     * @param value
     */
    selectEditField(value) {
      this.$emit('selectEditField', value);
    },
    disabledCooperation(value) {
      if (this.isPureLive) {
        return ['纯直播'].indexOf(value) === -1
      } else {
        if (this.formData.is_mark) {
          return ['红人全案', '年框大全案'].indexOf(value) === -1;
        } else if (this.formData.project_type === 3) {
          return ['普客打包'].indexOf(value) === -1
        } else {
          return ['红人全案', '普客打包', '年框大全案', '纯直播'].indexOf(value) !== -1;
        }
      }
    },
    /**
     * 获取红人名称输入建议
     */
    getKolList(val) {
      getFBoyOption({
        nickname: val || this.formData.artist_name
      }).then((_list) => {
        this.kolOptions = _list.model || []
      });
    },
    selectFavouriteBoy(value) {
      let row = this.kolOptions.find(val => val.value === value)
      this.formData.artist_name = row ? row.nickname : ''
      this.formData.agent_name = row ? row.agent_name : ''
      this.formData.artist_id = row ? row.id : ''
    },
    setArtistNames() {
      const _this = this
      //判断红人可选个数
      // if(this.formData.artist_ids){
      //   const len = this.formData.artist_ids ? this.formData.artist_ids.length : 0
      //   if (this.maxKol > 0 && len > this.maxKol) {
      //     //若限制 最多可选红人
      //     this.$notify.warning(`您选了${this.formData.artist_ids.length}个红人，最多可选${this.maxKol}个红人`)
      //   }
      // }

      if (this.kolOptions) {
        let artistIds = []
        let artistNms = []
        this.formData.artist_ids.map(function (id) {
          let row = _this.kolOptions.find(val => val.value === id)
          _this.formData.artist_nms = row ? row.agent_name : ''
          const artistId = row ? row.id : ''
          const artistName = row ? row.nickname : ''
          if (artistId && artistName) {
            artistIds.push(artistId)
            artistNms.push(artistName)
          }
        })
        _this.formData.artist_ids = artistIds
        _this.formData.artist_nms = artistNms
        _this.formData.artist_nm_str = artistNms ? artistNms.join('，') : '';
      }
    },
    selectedExecutor(val) {
      let option = this.executorOptions.find(value => value.value === val)
      this.formData.pre_executor = option ? option.label : ''
      this.clearEditField();
    },
    selectedCommerce(val) {
      let option = this.commerceOption.find(value => value.value === val)
      this.formData.commerce = option ? option.label : ''
      this.clearEditField();
    },
    syncCustomerBtn() {
      if (this.formData.id !== undefined) {
        this.$msgbox.confirm('是否同步客户信息？', '提示', {
          type: 'warning'
        }).then(() => {
          this.syncCustomer(this.formData.order_no)
          this.$message.success('同步完成');

          this.$nextTick(() => {
            setTimeout(() => {
              this.$emit('refresh')
            }, 1000)
          })
        }).catch(() => {
          this.$message.info('放弃同步');
        });
      }
    },
    //删除
    async syncCustomer(order_no) {
      await syncMainInfo({ order_no: order_no }).then(res => {
        return res.model
      })
    },
    // 处理搜索结果的选中
    handleSelect(value) {
      const item = this.formData.exec_corp.find(item => item.corp_id === value)
      this.formData.exec_customer_id = item.corp_id ? item.corp_id : 0
      this.formData.exec_customer_name = item.corp_nm ? item.corp_nm : ''
    },
    // 获取执行公司列表
    async loadExecCorpOption() {
      this.execCorpOptionLoading = true
      await execCorpSearchOption(this.formData.customer_id)
          .then((res) => {
            this.$nextTick(() => {
              this.formData.exec_corp = res.model.data || []
              this.formData.exec_customer_id = null
              this.formData.exec_customer_name = ''
            })
          })
      this.execCorpOptionLoading = false
    },
  }
}
</script>

<style lang="scss" scoped>
.part-base-party-a-container {
  .main {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;

    .customer-combine {
      position: relative;

      .combine {
        position: absolute;
        width: calc(100% + 40px);
        font-size: 12px;
        transform: scale(0.75);
        transform-origin: 0 0;
        line-height: 1;
        padding-top: 4px;
        top: -14px;
        left: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    ::v-deep {
      .el-form-item {
        margin-right: 0;
        .el-form-item__label {
          width: 97px;
        }

        .el-form-item__content {
          width: calc((100% - 97px));
        }
      }

      .el-input, .input-val, .el-select {
        width: 100% !important;
        max-width: unset !important;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }

  .main {
    @media only screen and (min-width: 1200px) {
      .el-form-item {
        width: 33.33%;
      }

      .double-width-item {
        width: 66.66% !important;
      }

    }

    @media only screen and (min-width: 1380px) {
      .el-form-item {
        width: 25%;
      }
      .double-width-item {
        width: 50% !important;
      }
    }

    @media only screen and (min-width: 1600px) {
      .el-form-item {
        width: 20%;
      }
      .double-width-item {
        width: 40% !important;
      }
    }
  }

  .custom-form-item {
    .el-form-item__label:before {
      content: "*";
      color: #FFF;
      margin-right: 4px;
    }
  }
}
</style>
